import { List, ListItem, ListItemText, Popover } from "@material-ui/core";
import { Settings } from "@material-ui/icons";
import { AppBarButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { useUrl } from "@ofqual/portal-core/core/hooks";
import { useState } from "react";

export type DashboardType = "Default" | "" | "LastResponse";
const dashboardParam = "dashboardName";

export const DashboardPopver: React.FC = () => {
  const [anchor, setAnchor] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const { navigate } = useUrl();

  const handleMenuClose = () => {
    setAnchor(null);
    setOpen(false);
  };

  const handleMenuOpen = (event: any) => {
    setAnchor(event.currentTarget);
    setOpen(true);
  };

  const handleDashboardClick = (dashboardType: DashboardType) => {
    switch (dashboardType) {
      case "Default":
      case "":
        navigate({});
        return;
      case "LastResponse":
        navigate({ [dashboardParam]: dashboardType });
        return;
    }
  };

  return (
    <>
      <AppBarButton
        onClick={handleMenuOpen}
        Icon={Settings}
        data-test="select-dashboard-button"
      />
      <Popover
        open={isOpen}
        onClose={handleMenuClose}
        anchorEl={anchor}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <List>
          <ListItem
            data-test="dashboard-menu-1"
            onClick={() => handleDashboardClick("")}
            button
          >
            <ListItemText primary="Default" />
          </ListItem>

          <ListItem
            data-test="dashboard-menu-2"
            onClick={() => handleDashboardClick("LastResponse")}
            button
          >
            <ListItemText primary="Dashboard 2" />
          </ListItem>
        </List>
      </Popover>
    </>
  );
};
